import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, MapPin, CalendarDays, Trophy } from "lucide-react";
import { useSite } from "../../contexts/SiteContext";
import { SPORTS } from "../../lib/sports";

const Field = ({ icon: I, label, children, last }) => (
  <label className={`flex-1 min-w-0 flex items-center gap-3 px-5 py-3 lg:py-2 rounded-full hover:bg-slate-100 transition-colors cursor-pointer ${last ? "" : "lg:border-r lg:border-slate-200 lg:rounded-none"}`}>
    <I className="w-5 h-5 text-[#1D4ED8] shrink-0" />
    <span className="flex flex-col min-w-0 w-full">
      <span className="text-[11px] font-bold uppercase tracking-wider text-[#0A1628]">{label}</span>
      {children}
    </span>
  </label>
);
const cls = "bg-transparent text-[15px] text-slate-600 outline-none w-full truncate cursor-pointer appearance-none placeholder:text-slate-400";

export const SearchBar = ({ initial = {} }) => {
  const { L, sportLabel, enabledSports } = useSite();
  const nav = useNavigate();
  const [sport, setSport] = useState(initial.sport || "");
  const [location, setLocation] = useState(initial.location ?? "Los Angeles");
  const [when, setWhen] = useState(initial.when || "");
  const sports = SPORTS.filter((s) => !enabledSports.length || enabledSports.includes(s.id));
  const go = (e) => {
    e.preventDefault();
    const p = new URLSearchParams();
    if (sport) p.set("sport", sport);
    if (location) p.set("location", location);
    if (when) p.set("when", when);
    nav(`/find-coaches?${p.toString()}`);
  };
  return (
    <form onSubmit={go} className="w-full bg-white rounded-[28px] lg:rounded-full shadow-[0_24px_60px_-20px_rgba(10,22,40,.45)] p-2 flex flex-col lg:flex-row lg:items-center gap-1" data-testid="hero-search-bar">
      <Field icon={Trophy} label={L("Sport", "Спорт")}>
        <select value={sport} onChange={(e) => setSport(e.target.value)} className={cls} data-testid="search-sport-select">
          <option value="">{L("All sports", "Всички спортове")}</option>
          {sports.map((s) => <option key={s.id} value={s.id}>{sportLabel(s.id)}</option>)}
        </select>
      </Field>
      <Field icon={MapPin} label={L("Where", "Къде")}>
        <input value={location} onChange={(e) => setLocation(e.target.value)} placeholder={L("City or ZIP", "Град или пощ. код")} className={cls} data-testid="search-location-input" />
      </Field>
      <Field icon={CalendarDays} label={L("When", "Кога")} last>
        <select value={when} onChange={(e) => setWhen(e.target.value)} className={cls} data-testid="search-when-select">
          <option value="">{L("Any time", "По всяко време")}</option>
          <option value="7">{L("Next 7 days", "Следващите 7 дни")}</option>
          <option value="14">{L("Next 2 weeks", "Следващите 2 седмици")}</option>
        </select>
      </Field>
      <button type="submit" className="otp-btn otp-shine h-14 px-7 rounded-full bg-[#1D4ED8] hover:bg-[#1E40AF] text-white font-semibold inline-flex items-center justify-center gap-2 shrink-0" data-testid="search-submit-btn">
        <Search className="w-5 h-5" /> <span className="lg:hidden xl:inline">{L("Search coaches", "Търси треньори")}</span>
      </button>
    </form>
  );
};
